/*
 * 표 레이아웃(tabletV 이상)의 열 너비. 머리글과 행이 같은 값을 써야 줄이 맞는다.
 * tabletV(1180px)에서는 사이드바를 빼면 본문이 700px 남짓이라 좁게 잡고, desktopL(1440px)부터 넓힌다.
 */
export const USER_COLUMN_CLASS = {
  joined: 'flex-shrink-0 w-[84px] desktopL:w-[100px]',
  id: 'flex-shrink-0 w-[56px] desktopL:w-[70px]',
  name: 'flex-1 min-w-[120px]',
  email: 'flex-shrink-0 w-[160px] desktopL:w-[240px] min-w-0',
  type: 'flex-shrink-0 w-[150px] desktopL:w-[200px]',
  lastLogin: 'flex-shrink-0 w-[84px] desktopL:w-[110px]',
  options: 'flex-shrink-0 w-[44px] desktopL:w-[60px]',
};
